/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'CportalModule';
const componentName = 'cportal-page';
const prefix = `${moduleName}.${componentName}`;

export const cloudServicesLabel = `${prefix}.cloudServicesLabel`;
export const editCloudServicesSettingsTooltip = `${prefix}.editCloudServicesSettingsTooltip`;
export const reconnectNowLabel = `${prefix}.reconnectNowLabel`;
export const connectedLabel = `${prefix}.connectedLabel`;
export const disconnectedLabel = `${prefix}.disconnectedLabel`;
export const disconnectFromCloudServiceLabel = `${prefix}.disconnectFromCloudServiceLabel`;
export const connectionErrorMessage = `${prefix}.connectionErrorMessage`;
export const disconnectFromCloudServiceMessage = `${prefix}.disconnectFromCloudServiceMessage`;
export const cloudServicesRegisterControllerMessage = `${prefix}.cloudServicesRegisterControllerMessage`;
export const controllerRegisteredControllerBtnLabel = `${prefix}.controllerRegisteredControllerBtnLabel`;
export const notConnectedErrorMessage = `${prefix}.notConnectedErrorMessage`;
export const notRegisteredAndConnectedErrorMessage = `${prefix}.notRegisteredAndConnectedErrorMessage`;
export const attemptingToConnectMessage = `${prefix}.attemptingToConnectMessage`;
export const learnMoreLink = `${prefix}.learnMoreLink`;
export const portalUrlLabel = `${prefix}.portalUrlLabel`;
export const reconnectLabel = `${prefix}.reconnectLabel`;
export const enabledLabel = `${prefix}.enabledLabel`;
export const deactivatedLabel = `${prefix}.deactivatedLabel`;

export const ENGLISH = {
    [cloudServicesLabel]: 'Cloud Services',
    [editCloudServicesSettingsTooltip]: 'Edit Cloud Services settings',
    [reconnectNowLabel]: 'Reconnect now.',
    [connectedLabel]: 'Connected',
    [disconnectedLabel]: 'Disconnected',
    [disconnectFromCloudServiceLabel]: 'Disconnect from cloud service',
    [controllerRegisteredControllerBtnLabel]: 'Complete Registration',
    [connectionErrorMessage]: 'A connection error has occurred, Controller will auto-retry in 10 seconds.',
    [notConnectedErrorMessage]: 'We successfully made a connection to Cloud Services but was unable to complete registration, Please try again.',
    [notRegisteredAndConnectedErrorMessage]: 'Register your Controller with Cloud Services to take advantage of auto-updates in Controller support and more.',
    [attemptingToConnectMessage]: 'Controller attempting to connect to Cloud Services, Please wait to complete registration. This may take several minutes.',
    [disconnectFromCloudServiceMessage]: 'This will disconnect you from Cloud Services.',
    [cloudServicesRegisterControllerMessage]: 'Cloud Services must be connected for registering Controller.',
    [learnMoreLink]: 'Learn More',
    [portalUrlLabel]: 'Portal URL',
    [reconnectLabel]: 'Reconnect',
    [enabledLabel]: 'Enabled',
    [deactivatedLabel]: 'Deactivated',
};
